export default __webpack_public_path__ + "static/media/a16.e5806c67.jpg";